"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var WithdrawalIsAccepted = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeModal = (0, apps_shared_1.useCloseModal)();
    return (react_1.default.createElement(ui_components_1.Modal, { width: "440px", height: "370px", portalNodeId: "modal", onClose: closeModal },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAccepted'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAcceptedDescription'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAcceptedDescription2'),
                } }),
            react_1.default.createElement(ui_components_2.FixedButton, { color: "gradient", text: "upper", onClick: closeModal }, t('ok')))));
};
exports.default = WithdrawalIsAccepted;
